export const constant = {
	selector: {
		handler: 'js-submitter-handler',
	},
	useJqueryHandlerClass: 'js-use-jquery-handler',
}
